import React from 'react';

const FinishSignInSkeleton: React.FC = () => (
  <div
    role="status"
    aria-label="Completing sign in"
    className="flex flex-col items-center justify-center min-h-screen w-full bg-[#FFFFFF] font-raleway relative overflow-hidden px-4"
  >
    <div className="absolute inset-0 w-full h-full animate-shimmer bg-gradient-to-r from-transparent via-white/60 to-transparent z-10 pointer-events-none" />
    <div className="border border-[#E9E9E9] rounded-xl bg-white p-10 max-w-md w-full shadow-sm space-y-6 relative">
      <div className="w-16 h-16 bg-gray-200/70 rounded-full mx-auto animate-pulse" />
      <div className="h-6 bg-gray-200/70 rounded w-48 mx-auto animate-pulse" />
      <div className="space-y-2">
        <div className="h-3 bg-gray-200/70 rounded w-full animate-pulse" />
        <div className="h-3 bg-gray-200/70 rounded w-5/6 mx-auto animate-pulse" />
      </div>
      <div className="h-10 bg-gray-200/70 rounded-md w-full animate-pulse" />
    </div>
    <span className="sr-only">Completing sign in...</span>
  </div>
);

export default FinishSignInSkeleton;
